
/**
 * 응답 데이터
 * @nullable
 */
export type PostApiV1RefundsCancelSubscription200AllOfData = { [key: string]: unknown } | null;
